<template>
  <section class="container list-style05-wrap mt-9">
    <p class="list-style-srch--total">
      <span class="list-style-srch--txt">총 <span class="color-orange">{{searchedProducts.length}}</span>건의 결과</span>
    </p>
    <ul class="row list-style05 mt-10">
      <li class="col-6 col-sm-4" v-for="product in searchedProducts" :key="product.name">
        <a href="" @click.prevent="moveToDetailPage(product.productsId)">
          <div class="list-style05--img mb-2">
            <img :src="product.productsMainImageUrl" alt="">
          </div>
          <h3 class="list-style05--tit">{{product.productsPageKoreanName}}</h3>
          <p class="list-style05--desc">{{product.productsPageEnglishName}}</p>
        </a>
      </li>
    </ul>
    <!-- 검색 결과 없을 경우 -->
    <div class="text-center no-result mt-7" v-if="searchedProducts.length === 0">
      <img src="@/assets/images/common/warning.png" alt="!" class="mb-2 warn">
      <span>{{searchWord}}</span>에 대한 검색결과가 없습니다.<br>
      다시 검색해주시기 바랍니다.
    </div>
  </section>
</template>

<script>
export default {
  name: 'Result',
  props: {
    searchWord: {
      type: String,
      default: '',
    },
    searchedProducts: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    moveToDetailPage(productId) {
      this.$router.push({ name: 'ProductDetail', params: { productId } });
    },
  },
};
</script>

<style lang='scss' scoped>
.list-style-srch{
  &--total{
    text-align: center;
    background: url(~@/assets/images/common/line_horizon_gray2.svg) repeat-x center;
    font-size: 2rem;
  }
  &--txt{
    padding: 0 2rem;
    background: white;
  }
}
.warn{
  display: block;
  margin: auto;
}
</style>
